module.exports = __webpack_public_path__ + "img/404-logo.7735fa19.png";